import React from 'react';
import { twMerge } from 'tailwind-merge';

import { VideoCardTitle } from './VideoCardTitle';

export interface VideoCardOverlayProps {
  duration: number;
  title: string;
  shouldInvertControlsVisibility: boolean;
  isHovering: boolean;
  className?: string;
}

export const VideoCardOverlay = ({
  duration,
  title,
  shouldInvertControlsVisibility,
  isHovering,
  className = '',
}: VideoCardOverlayProps) => {
  return (
    <>
      <div
        data-testid="video-card-overlay"
        className={twMerge(
          'absolute inset-0 flex items-center justify-center rounded-lg pointer-events-none',
          isHovering ? 'opacity-100' : 'opacity-0',
          className
        )}
        style={{
          background:
            'linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 40%)',
        }}
      />
      <VideoCardTitle
        duration={duration}
        title={title}
        shouldInvertControlsVisibility={shouldInvertControlsVisibility}
        isHovering={isHovering}
      />
    </>
  );
};
